/**
 * Attendance module home: live clock + work-progress ring.
 * The server stamps #attendance-today with epoch/schedule data attributes;
 * this ticks once a second, correcting for client clock drift against the
 * server-provided "now" and deducting the lunch-window overlap exactly like
 * the server-side judgment does.
 */
const RING_CIRCUMFERENCE = 603.19; // 2πr for r=96, keep in sync with the SVG

function pad(n) {
    return String(n).padStart(2, '0');
}

// showClockSplash: 출퇴근 결과를 화면 중앙 스플래시로 크게 보여준다.
// 성공은 초록 ✓ 팝 + 시각과 함께 잠시 표시 후 사라지고, 실패는 빨간 ✗와
// 사유를 보여주며 클릭(또는 3.5초)으로 닫는다.
function showClockSplash(message, isError) {
    const overlay = document.createElement('div');
    overlay.className = 'att-splash-overlay';
    const card = document.createElement('div');
    card.className = 'att-splash' + (isError ? ' att-splash-error' : '');
    const icon = document.createElement('div');
    icon.className = 'att-splash-icon';
    icon.textContent = isError ? '✗' : '✓';
    const msg = document.createElement('div');
    msg.className = 'att-splash-msg';
    msg.textContent = message;
    card.appendChild(icon);
    card.appendChild(msg);
    if (!isError) {
        const t = new Date();
        const sub = document.createElement('div');
        sub.className = 'att-splash-time';
        sub.textContent = pad(t.getHours()) + ':' + pad(t.getMinutes());
        card.appendChild(sub);
    }
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    const dismiss = () => {
        overlay.classList.add('att-splash-out');
        setTimeout(() => overlay.remove(), 250);
    };
    if (isError) {
        overlay.addEventListener('click', dismiss);
        setTimeout(dismiss, 3500);
    } else {
        setTimeout(dismiss, 1700);
        // 오늘 카드에 강조 펄스
        const today = document.getElementById('attendance-today');
        if (today) {
            today.classList.add('att-card-pulse');
            setTimeout(() => today.classList.remove('att-card-pulse'), 2000);
        }
    }
}

export function setupAttendanceLive() {
    // 출퇴근 결과 플래시: 중앙 스플래시로 무엇이 일어났는지 크게 보여준다.
    const flash = document.getElementById('attendance-flash');
    if (flash && flash.dataset.message) {
        showClockSplash(flash.dataset.message, flash.dataset.error === '1');
        // 새로고침 시 반복되지 않도록 ?att= 쿼리를 지운다.
        const url = new URL(window.location.href);
        if (url.searchParams.has('att')) {
            url.searchParams.delete('att');
            window.history.replaceState({}, '', url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : ''));
        }
    }

    const card = document.getElementById('attendance-today');
    if (!card) return;

    const clockEl = document.getElementById('attendance-clock');
    const ring = document.getElementById('attendance-ring-progress');
    const pctEl = document.getElementById('attendance-ring-pct');
    const labelEl = document.getElementById('attendance-ring-label');

    const serverNow = parseInt(card.dataset.serverNowEpoch, 10) || 0;
    const clockIn = parseInt(card.dataset.clockInEpoch, 10) || 0;
    const done = card.dataset.done === '1';
    const lunchStart = parseInt(card.dataset.lunchStartEpoch, 10) || 0;
    const lunchEnd = parseInt(card.dataset.lunchEndEpoch, 10) || 0;
    const breakMinutes = parseInt(card.dataset.breakMinutes, 10) || 0;
    const scheduled = parseInt(card.dataset.scheduledMinutes, 10) || 0;
    const tzOffsetMin = parseInt(card.dataset.tzOffsetMinutes, 10) || 0;
    const weekdays = (card.dataset.weekdays || '일,월,화,수,목,금,토').split(',');
    const drift = serverNow ? serverNow - Math.floor(Date.now() / 1000) : 0;

    function tick() {
        const nowEpoch = Math.floor(Date.now() / 1000) + drift;

        if (clockEl) {
            // Render in the attendance timezone via the server-provided offset.
            const t = new Date((nowEpoch + tzOffsetMin * 60) * 1000);
            clockEl.textContent =
                String(t.getUTCFullYear()).slice(2) + '-' + pad(t.getUTCMonth() + 1) + '-' + pad(t.getUTCDate()) +
                ' (' + (weekdays[t.getUTCDay()] || '') + ') ' +
                pad(t.getUTCHours()) + ':' + pad(t.getUTCMinutes()) + ':' + pad(t.getUTCSeconds());
        }

        // Ring only advances while working (clocked in, not out).
        if (!clockIn || done || scheduled <= 0) return;
        let secs = nowEpoch - clockIn;
        if (lunchStart && lunchEnd) {
            const oStart = Math.max(clockIn, lunchStart);
            const oEnd = Math.min(nowEpoch, lunchEnd);
            if (oEnd > oStart) secs -= oEnd - oStart;
        } else secs -= breakMinutes * 60;
        const mins = Math.max(0, Math.floor(secs / 60));
        const pct = Math.min(100, Math.floor((mins * 100) / scheduled));
        if (ring) ring.setAttribute('stroke-dashoffset', ((RING_CIRCUMFERENCE * (100 - pct)) / 100).toFixed(2));
        if (pctEl) pctEl.textContent = pct + '%';
        if (labelEl) labelEl.textContent = Math.floor(mins / 60) + 'h ' + pad(mins % 60) + 'm';
    }

    tick();
    setInterval(tick, 1000);
}
